import { TextField } from '@mui/material'
import { TextBody } from 'components'
import { AuthInputContainer } from '../Auth.styled'

const AuthEmailInput = props => {
  const { email, handleInputChange, error, ...rest } = props

  return (
    <AuthInputContainer mb="1rem">
      <TextBody variant="subtitle" fontWeight={600}>
        Email
      </TextBody>
      <TextField
        name="email"
        placeholder="Enter your email..."
        fullWidth
        margin="normal"
        variant="outlined"
        value={email}
        onChange={handleInputChange}
        error={!!error}
        helperText={error}
        {...rest}
      />
    </AuthInputContainer>
  )
}

export default AuthEmailInput
